import { __assign, __extends, __rest } from "tslib";
import React from 'react';
import classnames from 'classnames';
import { withTranslation } from 'react-i18next';
import { URLS, Url } from '@wix/da-url';
import { ModalType } from '../../../Modals/redux/types';
import Button from '../../../Button';
import SubmitMenuItem from '../../_partials/MobileSubmitMenuItem';
import { BiEventType } from '../../../biLogger/constants';
import s from './BurgerMenu.scss';
var SubmitMenu = /** @class */ (function (_super) {
    __extends(SubmitMenu, _super);
    function SubmitMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.submitMenuItems = [
            {
                key: 'siteHeader.deviation',
                url: URLS.SUBMIT,
                verificationAction: 'submit',
                biData: {
                    evid: BiEventType.TOP_NAV_MENU_CLICK,
                    menu_item: 'deviation',
                    menu_name: 'submit',
                    link_url: URLS.SUBMIT,
                },
            },
            __assign({ key: 'siteHeader.statusUpdate', verificationAction: 'submitstatus' }, _this.getItemProps(ModalType.STATUS_UPDATE)),
            __assign({ key: 'siteHeader.poll', verificationAction: 'submitpoll' }, _this.getItemProps(ModalType.POLL_EDIT)),
        ];
        return _this;
    }
    SubmitMenu.prototype.getItemProps = function (type) {
        var _a;
        var types = (_a = {},
            _a[ModalType.STATUS_UPDATE] = 'status',
            _a[ModalType.POLL_EDIT] = 'poll',
            _a);
        var biData = {
            evid: BiEventType.TOP_NAV_MENU_CLICK,
            menu_item: types[type],
            menu_name: 'submit',
        };
        if (this.props.isLegacyHeader) {
            var url = Url.browseHomeLink() + "?submit_modal=" + types[type];
            return {
                url: url,
                biData: __assign({ link_url: url }, biData),
            };
        }
        return { onClick: this.openModal(type), biData: biData };
    };
    SubmitMenu.prototype.openModal = function (type, options) {
        var _this = this;
        return function () {
            _this.props.pushModal(type, __assign({ wrapInPopup: false }, options));
        };
    };
    SubmitMenu.prototype.render = function () {
        var _a = this.props, t = _a.t, isOpen = _a.isOpen, onToggle = _a.onToggle;
        return (React.createElement("div", { className: s['submit-menu-block'] },
            React.createElement("div", { className: classnames(s['submit-menu-shade'], isOpen && s['is-active']), onClick: onToggle }),
            React.createElement("div", { className: classnames(s['submit-menu-wrapper'], isOpen && s['is-opened']) },
                React.createElement(Button, { className: s['submit-button'], onClick: onToggle },
                    t('siteHeader.submit'),
                    ' ',
                    React.createElement("span", { className: s['plus-minus-icon'] }, isOpen ? '−' : '+')),
                React.createElement("ul", { className: s['submit-menu'] }, this.submitMenuItems.map(function (_a) {
                    var key = _a.key, props = __rest(_a, ["key"]);
                    return (React.createElement("li", { key: key },
                        React.createElement(SubmitMenuItem, __assign({}, props, { className: classnames(s['list-item']) }), t(key))));
                })))));
    };
    return SubmitMenu;
}(React.Component));
export { SubmitMenu };
export default withTranslation()(SubmitMenu);
//# sourceMappingURL=SubmitMenu.js.map